module.exports = __webpack_public_path__ + "static/media/nu.d3fb32b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/nu.png
// module id = 1948
// module chunks = 0